// extracted by css-extract-rspack-plugin
var _1 = "policy-link__qKEb3";
var _2 = "termsField__nY8zU";
var _3 = "termsField__checkbox__vwTZj";
var _4 = "termsField__helpText__Htb5E";
var _5 = "termsField__helpText__description__UQtx0";
var _6 = "termsField__helpText__label__ry2sH";
export { _1 as "policy-link", _2 as "termsField", _3 as "termsField__checkbox", _4 as "termsField__helpText", _5 as "termsField__helpText__description", _6 as "termsField__helpText__label" }
export default { "policy-link": _1, "termsField": _2, "termsField__checkbox": _3, "termsField__helpText": _4, "termsField__helpText__description": _5, "termsField__helpText__label": _6 }
